/* unplugin-vue-components disabled */import { render } from "./TextLogicalReasoningRender.vue?vue&type=template&id=a6e4a24c&scoped=true"
import script from "./TextLogicalReasoningRender.vue?vue&type=script&lang=js"
export * from "./TextLogicalReasoningRender.vue?vue&type=script&lang=js"

import "./TextLogicalReasoningRender.vue?vue&type=style&index=0&id=a6e4a24c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6e4a24c"]])

export default __exports__